/**
 * assertNever is a utility function that throws an error if the value passed to it is not of type 'never'.
 * This is useful for exhaustive type checking in TypeScript, ensuring that all possible cases of a union type are handled.
 * If a new case is added to the union type and not handled in the switch statement, this function will throw an error.
 */
export const assertNever = (value: never, errorMessage?: string): never => {
	throw new Error(
		errorMessage ??
			`Unexpected value: ${value}. This is a type error, please check the type of the value passed to this function.`,
	);
};
